module.exports = (parcelRequire.load("gTqGi")).then(() => parcelRequire('3yhnZ'));